import { type LatLng } from '../../types/latLng';
import { type IndividualRadiusProximity } from '../../types/proximity/proximity.types';

export const changeIndividualProximityLatLng = <T extends IndividualRadiusProximity> (proximity: T, newLatLng: LatLng): T => ({
  ...proximity,
  data: { ...proximity.data, data: { ...proximity.data.data, ...newLatLng } },
});
